import { Stack } from '@mui/material'
import { useStytchIsAuthorized } from '@stytch/react/b2b'
import { OverlayState } from '@/hooks/useOverlay'
import { FormTextField } from '@/components/forms'
import UserRolesPicker from './UserRolesPicker'

type UserCoreInfoProps = {
  overlay: OverlayState
}

export default function UserCoreInfo({ overlay }: UserCoreInfoProps) {
  const { isAuthorized: canEditRoles } = useStytchIsAuthorized(
    'pd.user',
    'edit.roles',
  )

  return (
    <Stack spacing={4} sx={{ px: 3 }}>
      <FormTextField
        name="name"
        autoFocus
        fullWidth
        label="Name"
        required
        useControllerProps={{
          rules: {
            validate: (value) => value.trim().length > 0,
          },
        }}
      />
      <FormTextField
        name="email_address"
        fullWidth
        type="email"
        label="Email"
        required
        useControllerProps={{
          rules: {
            validate: (value) =>
              /^[^@ ]+@[0-9A-Za-z-]+(\.[0-9A-Za-z-]+)+$/.test(value),
          },
        }}
      />

      {canEditRoles && (
        <>
          <FormTextField name="employee_ext_id" fullWidth label="Employee ID" />
          <UserRolesPicker overlay={overlay} />
        </>
      )}
    </Stack>
  )
}
